import { Component, Input } from '@angular/core';
import { ErrorService } from '@app/services';
import { EntityTableComponent } from '@app/abstracts';
import { ModuleEnSavoirPlusSearchParams } from '../module-en-savoir-plus-search-params';
import { ModuleEnSavoirPlusService } from '../module-en-savoir-plus.service';
import { ModuleEnSavoirPlus } from '../module-en-savoir-plus';

@Component({
	selector: 'hpf-module-en-savoir-plus-table',
	templateUrl: './module-en-savoir-plus-table.component.html',
})
export class ModuleEnSavoirPlusTableComponent extends EntityTableComponent<
	ModuleEnSavoirPlus,
	ModuleEnSavoirPlusSearchParams
> {
	/** Columns to show */
	@Input() columns = ['created_at', 'title', 'label', 'subtitle', 'url'];
	/** Constructor */
	constructor(
		private moduleEnSavoirPlusService: ModuleEnSavoirPlusService,
		private errorService: ErrorService
	) {
		super();
	}
	/** @inheritDoc */
	protected refresh(): void {
		const params = this.searchParams.toObject();
		// Set refreshing flag
		this.refreshing = true;
		// Get list
		this.moduleEnSavoirPlusService
			.list(params)
			.then((results) => {
				// Link data
				this.items = results.items;
				this.total = results.total;
			})
			.catch((error) => this.errorService.handle(error))
			.then(() => {
				this.refreshing = false;
			});
	}

	/** Called when the user select multiple rows and delete them */
	async removeMany() {
		if (!this.selectedRows.length) {
			return;
		}

		this.deleting = true;
		for (const item of this.selectedRows) {
			await this.moduleEnSavoirPlusService
				.remove(item.getId())
				.catch((e) => this.errorService.handle(e));
		}

		this.deleteMany.next(this.selectedRows);
		this.resetSelectedRows();
		this.deleting = false;
		this.deleteManyModal = false;
		this.searchParams.next();
	}
	/** Called when the user delete a single row */
	async removeOne() {
		if (!this.rowToDelete) {
			return;
		}

		this.deleting = true;
		await this.moduleEnSavoirPlusService
			.remove(this.rowToDelete.getId())
			.catch((e) => this.errorService.handle(e));

		this.deleteOne.next(this.rowToDelete);
		delete this.rowToDelete;
		this.deleting = false;
		this.deleteOneModal = false;
		this.searchParams.next();
	}
}
